import { useState } from "react";
import { Button } from "~/components/ui/button";
import { Popover, PopoverPopup, PopoverTrigger } from "~/components/ui/popover";

export function EnrollmentClinicMultiSelect(props: {
  clinics: { id: string; name: string }[];
  selected: string[];
  onChange: (ids: string[]) => void;
  label: string;
}) {
  const [search, setSearch] = useState("");
  const matching = props.clinics.filter((clinic) =>
    clinic.name.toLowerCase().includes(search.toLowerCase()),
  );
  return (
    <Popover>
      <PopoverTrigger render={<Button variant="outline" />} aria-label={props.label}>
        Clinics · {props.selected.length} selected
      </PopoverTrigger>
      <PopoverPopup className="w-80" align="start">
        <input
          aria-label={props.label + " search"}
          placeholder="Search all clinics…"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          className="mb-3 h-8 w-full rounded-md border border-input bg-background px-2 text-sm"
        />
        <div className="mb-3 flex gap-2">
          <Button
            size="sm"
            variant="outline"
            onClick={() => props.onChange(props.clinics.map((clinic) => clinic.id))}
          >
            Select all
          </Button>
          <Button size="sm" variant="outline" onClick={() => props.onChange([])}>
            Clear
          </Button>
        </div>
        <fieldset className="max-h-64 space-y-2 overflow-y-auto">
          <legend className="sr-only">{props.label}</legend>
          {matching.map((clinic) => (
            <label key={clinic.id} className="flex cursor-pointer items-center gap-2 text-sm">
              <input
                type="checkbox"
                checked={props.selected.includes(clinic.id)}
                onChange={(event) =>
                  props.onChange(
                    event.target.checked
                      ? [...props.selected, clinic.id]
                      : props.selected.filter((id) => id !== clinic.id),
                  )
                }
              />
              {clinic.name}
            </label>
          ))}
          {!matching.length ? (
            <p className="text-sm text-muted-foreground">No clinics found.</p>
          ) : null}
        </fieldset>
      </PopoverPopup>
    </Popover>
  );
}
